import { ConfigService } from '@maia/config';
import { HttpService } from '@maia/httpClient';
import { ClaimController } from './claim.controller';
import {
  ActivityService,
  ClaimService,
  NoteService,
  TaskService,
} from '@maia/shared';

export class ClaimFactory {
  private readonly configService = new ConfigService();
  private readonly httpService = new HttpService(
    this.configService,
    'claimUrl',
  );

  createClaimController(): ClaimController {
    return new ClaimController(
      this.createClaimService(),
      this.createActivityService(),
      this.createNoteService(),
      this.createTaskService(),
    );
  }

  private createClaimService(): ClaimService {
    return new ClaimService(this.httpService, this.configService);
  }

  private createActivityService(): ActivityService {
    return new ActivityService(this.httpService, this.configService);
  }

  private createNoteService(): NoteService {
    return new NoteService(this.httpService, this.configService);
  }

  private createTaskService(): TaskService {
    return new TaskService(this.httpService, this.configService);
  }
}

const factory = new ClaimFactory();
export const service = factory.createClaimController();
